export default "__VITE_ASSET__KU6ovJQy__"